module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"creationDate":"Creation date"},"fr":{"creationDate":"Date de création"},"es":{"creationDate":"Fecha de creación"},"pt":{"creationDate":"Data de criação"},"ar":{"creationDate":"تاريخ الإنشاء"},"sv":{"creationDate":"Skapandedatum"},"fi":{"creationDate":"Luontipäivämäärä"},"ja":{"creationDate":"作成日"}}')
  delete Component.options._Ctor
}
